import React from "react";
import "./tabel.css";

const ResponsiveTable = ({ Material, Wire, Machine }) => {
  return (
    <div className="table-container my-10">
      <table>
        <tbody>
          <tr>
            <td className="font-semibold text-xl">Material</td>
            <td className="text-md text-mute-grey">{Material}</td>
          </tr>
          <tr>
            <td className="font-semibold text-xl w-[200px]">Wire Diameter</td>

            <td className="text-md text-mute-grey">{Wire}</td>
          </tr>
          <tr>
            <td className="font-semibold text-xl">Machine</td>

            <td className="text-md text-mute-grey">{Machine}</td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default ResponsiveTable;
